import { FORM_NAME } from '%paysera_simple_event/js/event/component/Form/config/constants';
import { createSelector } from 'reselect';
import { head, last } from 'lodash/array';
import { getFormValues } from 'redux-form';

export default createSelector(
    state => getFormValues(FORM_NAME)(state),
    (ticketTypes, hash) => hash,
    ({ ticket_types: ticketTypes, currency }, hash) => {
        const ticketType = ticketTypes.find(item => item.hash === hash);

        const prices = ticketType.price_types.map(priceType => priceType.price);
        if (prices.length === 1) {
            return `${head(prices)} ${currency}`;
        }

        const sortedPrices = prices.sort((fistPrice, secondPrice) => fistPrice - secondPrice);

        return `${head(sortedPrices)} - ${last(sortedPrices)} ${currency}`;
    },
);
